import React from 'react'
import Customer from '../code/models/Customer';
import AuthAdminUserModel from '../code/models/AuthAdminUserModel';
import Api_Config from '../code/api/ApiConfig';
import ApiCustomer from "../code/api/ApiCustomer";
import CustomerProduct from "../code/models/CustomerProduct";
import { BidNavVersion } from "../code/models/ApiConfigCompany";
import CustomerSubscriptionLegacy from "./CustomerSubscriptionLegacy";
import Toaster from "./Toaster";
import CclCurrencyInput from "./common/CclCurrencyInput";

interface ICustomerSubscriptionInfo {
    customer: Customer;
    currentUser: AuthAdminUserModel;
}

export default function CustomerSubscriptionInfo({ customer, currentUser }: ICustomerSubscriptionInfo) {
    const [customerProducts, setCustomerProducts] = React.useState<CustomerProduct[]>([]);
    const [toastMessage, setToastMessage] = React.useState<string>("");
    const company = Api_Config.getSelectedCompany();
    // Format the money
    const moneyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: company.currencyCode });

    React.useEffect(() => {
        loadSubscriptionInfo();
    }, []);

    async function loadSubscriptionInfo() {
        ApiCustomer.getCustomerProducts(customer.customerId).then((custProds) => {
            setCustomerProducts(custProds);
        });
    }

    async function showMessage(message: string) {
        setToastMessage(message);
        setTimeout(() => {
            setToastMessage("");
        }, 5000);
    }

    function showSkipResultToast(skipped: boolean) {
        showMessage(`The customer now ${skipped ? "ON" : "OFF"} skip bidding.`);
    }


    function showUnableToast() {
        showMessage("Unabe to update customer.");
    }

    function handleSkipClick(custProduct: CustomerProduct) {
        if (!custProduct.productCanSkip) return;

        ApiCustomer.changeProductSkip(customer.customerId, custProduct.productId,
            !custProduct.skipBidding).then((res) => {
                loadSubscriptionInfo();
                showSkipResultToast(!custProduct.skipBidding);
            }).catch(() => {
                showUnableToast();
            });
    }

    function renderSubscriptionInfo() {
        if (!currentUser.canDoBilling) {
            return renderSubscriptionInfoReadOnly();
        } else {
            return renderSubscriptionInfoEdit();
        }
    }

    function updateProduct(custProduct: CustomerProduct): void {
        ApiCustomer.updateCustomerProduct(custProduct).then((res) => {
            if (!!res) {
                showMessage(`Product updated (${custProduct.productName}).`);
            }
        }).catch(() => {
            showMessage("Unabe to update product.");
        });
    }

    function renderSubscriptionInfoEdit() {
        return customerProducts.map((prod) => {
            return (
                <React.Fragment key={"cprod-" + prod.productId}>
                    <div className="row">
                        <div className="col-md-6">&nbsp;</div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">Product:</div>
                        <div className="col-md-2">{prod.productName}</div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">Monthly Charge:</div>
                        <div className="col-md-2">
                            <CclCurrencyInput id={"cpMonthly-" + prod.productId} className={"form-control"} defaultValue={prod.monthlyCharge} currencyPrefix={company.currency}
                                onChange={(value) => { prod.monthlyCharge = value }} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">Skip Charge:</div>
                        <div className="col-md-2">
                            <CclCurrencyInput id={"cpSkip-" + prod.productId}  className={"form-control"} defaultValue={prod.monthlySkipCharge} currencyPrefix={company.currency}
                                onChange={(value) => { prod.monthlySkipCharge = value }} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">&nbsp;</div>
                        <div className="col-md-2">
                            <button className="btn btn-sm btn-outline-primary mt-1" onClick={() => updateProduct(prod)}>Update</button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">Can Remove:</div>
                        <div className="col-md-2">{prod.productCanDelete ? "Yes" : "No"}</div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">Can Skip:</div>
                        <div className="col-md-2">{prod.productCanSkip ? "Yes" : "No"}</div>
                    </div>
                    {prod.productCanSkip && <div className="row">
                        <div className="col-md-2">Is On Skip:</div>
                        <div className="col-md-2">{prod.skipBidding ? "Yes" : "No"}</div>
                        <div className="col-md-2">
                            <button onClick={() => handleSkipClick(prod)}
                                className={"btn btn-sm btn-outline-primary"}>{prod.skipBidding ? "Cancel Skip" : "Skip"}</button>
                        </div>
                    </div>}
                </React.Fragment>
            )
        });
    }

    function renderSubscriptionInfoReadOnly() {
        return customerProducts.map((prod) => {
            return (
                <React.Fragment key={"cprod-" + prod.productId}>
                    <div className="row">
                        <div className="col-md-6">&nbsp;</div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">Product:</div>
                        <div className="col-md-2">{prod.productName}</div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">Monthly Charge:</div>
                        <div className="col-md-2">{moneyFormatter.format(prod.monthlyCharge)}</div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">Skip Charge:</div>
                        <div className="col-md-2">{moneyFormatter.format(prod.monthlySkipCharge)}</div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">Can Remove:</div>
                        <div className="col-md-2">{prod.productCanDelete ? "Yes" : "No"}</div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">Can Skip:</div>
                        <div className="col-md-2">{prod.productCanSkip ? "Yes" : "No"}</div>
                    </div>
                    {prod.productCanSkip && <div className="row">
                        <div className="col-md-2">Is On Skip:</div>
                        <div className="col-md-2">{prod.skipBidding ? "Yes" : "No"}</div>
                        <div className="col-md-2">
                            <button onClick={() => handleSkipClick(prod)}
                                className={"btn btn-sm btn-outline-primary"}>{prod.skipBidding ? "Cancel Skip" : "Skip"}</button>
                        </div>
                    </div>}
                </React.Fragment>
            )
        });
    }

    return (
        <React.Fragment>
            <div className="container">
                {company.bidNavVersion === BidNavVersion.BidNav20 && renderSubscriptionInfo()}
                {company.bidNavVersion === BidNavVersion.Legacy && <CustomerSubscriptionLegacy currentUser={currentUser} customerId={customer.customerId} />}
                {company.bidNavVersion === BidNavVersion.IE && <CustomerSubscriptionLegacy currentUser={currentUser} customerId={customer.customerId} />}
                {company.bidNavVersion === BidNavVersion.UK && <CustomerSubscriptionLegacy currentUser={currentUser} customerId={customer.customerId} />}
            </div>
            <Toaster key={"toast-sub-" + customer.customerId} title="Customer Subscription" subtitle={`${customer.name}`} message={toastMessage} />
        </React.Fragment >
    )
}

